import { render, staticRenderFns } from "./TabOrderEditor.vue?vue&type=template&id=69ba4cb0&scoped=true&"
import script from "./TabOrderEditor.vue?vue&type=script&lang=js&"
export * from "./TabOrderEditor.vue?vue&type=script&lang=js&"
import style0 from "./TabOrderEditor.vue?vue&type=style&index=0&id=69ba4cb0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ba4cb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider,VIcon,VTooltip})
